import { formatCalls, formatShare } from './nodeChartTheme';

/**
 * Одно число вместо графика.
 *
 * Сюда попадают выходы с единственным значением и вырожденные за период распределения:
 * «Причина несодержательного звонка» объявляет четыре класса, но если за период встретился
 * только «Не задано», столбчатая карточка занимала половину ряда ради одного столбца
 * и не сообщала ничего.
 */
const NodeStatTile = ({ rows, denominator, hint }) => {
  const row = rows[0];

  return (
    <div className="flex h-full flex-col justify-center py-2">
      <div className="text-3xl font-semibold leading-none">
        {row ? formatCalls(row.calls) : formatCalls(denominator)}
      </div>
      <p className="mt-1.5 text-sm">{row?.label ?? 'Нет распределения за период'}</p>
      {row && (
        <p className="mt-0.5 text-xs text-muted-foreground">
          {formatShare(row.share)} от применимых звонков
        </p>
      )}
      {hint && <p className="mt-2 text-xs text-muted-foreground">{hint}</p>}
    </div>
  );
};

export default NodeStatTile;
